/**
 * Bridge from module-scoped queryClient 401 handling into React.
 * Configured once at app root — keeps soft sign-out / toast out of the query layer.
 */
export type UnauthorizedHandler = () => Promise<void>;

let unauthorizedHandler: UnauthorizedHandler | null = null;

/** Wire (or clear) the handler queryClient calls on session-ending 401s. */
export function configureUnauthorizedHandler(
  handler: UnauthorizedHandler | null,
): void {
  unauthorizedHandler = handler;
}

export function getUnauthorizedHandler(): UnauthorizedHandler | null {
  return unauthorizedHandler;
}
